import { portfolioHashMap } from "../WealthSeriesPortfolioPage/components/WealthSeriesPortfolioTickers/tickerData";
export const idToFullNameMap = {
  // Regular portfolios
  [portfolioHashMap["atlas_growth"]]: "Atlas Accelerated Growth",
  [portfolioHashMap["atlas_low-risk-volatility"]]: "Atlas Secure Bluechip",
  [portfolioHashMap["atlas_fundamental"]]: "Atlas Undervalued Advantage",
  [portfolioHashMap["titan_growth"]]: "Titan Dynamic Upside",
  [portfolioHashMap["titan_low-risk-volatility"]]: "Titan Steady Guard",
  [portfolioHashMap["titan_fundamental"]]: "Titan Fundamental Edge",
  [portfolioHashMap["everest_growth"]]: "Everest Momentum Ascent",
  [portfolioHashMap["everest_low-risk-volatility"]]:
    "Everest Resilient Horizon",
  [portfolioHashMap["everest_fundamental"]]: "Everest Hidden Value Discovery",
  [portfolioHashMap["everest_defensive"]]: "Everest Capital Shield",
  [portfolioHashMap["everest_balanced"]]: "Everest Steady Climb",

  // Auto portfolios
  [portfolioHashMap["atlas_growth_auto"]]: "Atlas Accelerated Growth",
  [portfolioHashMap["atlas_low-risk-volatility_auto"]]: "Atlas Secure Bluechip",
  [portfolioHashMap["atlas_fundamental_auto"]]: "Atlas Undervalued Advantage",
  [portfolioHashMap["titan_growth_auto"]]: "Titan Dynamic Upside",
  [portfolioHashMap["titan_low-risk-volatility_auto"]]: "Titan Steady Guard",
  [portfolioHashMap["titan_fundamental_auto"]]: "Titan Fundamental Edge",
  [portfolioHashMap["everest_growth_auto"]]: "Everest Momentum Ascent",
  [portfolioHashMap["everest_low-risk-volatility_auto"]]:
    "Everest Resilient Horizon",
  [portfolioHashMap["everest_fundamental_auto"]]:
    "Everest Hidden Value Discovery",
  [portfolioHashMap["everest_defensive_auto"]]: "Everest Capital Shield",
  [portfolioHashMap["everest_balanced_auto"]]: "Everest Steady Climb",

  // Core portfolios (no auto versions)
  [portfolioHashMap["core_growth"]]: "Core Capital Jetstream",
  [portfolioHashMap["core_low-risk-volatility"]]: "Core Safe Harbor",
  [portfolioHashMap["core_balanced"]]: "Core Robust Anchor",
};

export const portfoliosData = {
  atlas: {
    ids: [
      portfolioHashMap["atlas_growth"],
      portfolioHashMap["atlas_low-risk-volatility"],
      portfolioHashMap["atlas_fundamental"],
      // Include auto portfolio IDs
      portfolioHashMap["atlas_growth_auto"],
      portfolioHashMap["atlas_low-risk-volatility_auto"],
      portfolioHashMap["atlas_fundamental_auto"],
    ],
    portfolios: [
      {
        name: "Accelerated Growth",
        url: "atlas_growth",
        id: portfolioHashMap["atlas_growth"],
        autoId: portfolioHashMap["atlas_growth_auto"],
      },
      {
        name: "Secure Bluechip",
        url: "atlas_low-risk-volatility",
        id: portfolioHashMap["atlas_low-risk-volatility"],
        autoId: portfolioHashMap["atlas_low-risk-volatility_auto"],
      },
      {
        name: "Undervalued Advantage",
        url: "atlas_fundamental",
        id: portfolioHashMap["atlas_fundamental"],
        autoId: portfolioHashMap["atlas_fundamental_auto"],
      },
    ],
  },
  titan: {
    ids: [
      portfolioHashMap["titan_growth"],
      portfolioHashMap["titan_low-risk-volatility"],
      portfolioHashMap["titan_fundamental"],
      // Include auto portfolio IDs
      portfolioHashMap["titan_growth_auto"],
      portfolioHashMap["titan_low-risk-volatility_auto"],
      portfolioHashMap["titan_fundamental_auto"],
    ],
    portfolios: [
      {
        name: "Dynamic Upside",
        url: "titan_growth",
        id: portfolioHashMap["titan_growth"],
        autoId: portfolioHashMap["titan_growth_auto"],
      },
      {
        name: "Steady Guard",
        url: "titan_low-risk-volatility",
        id: portfolioHashMap["titan_low-risk-volatility"],
        autoId: portfolioHashMap["titan_low-risk-volatility_auto"],
      },
      {
        name: "Fundamental Edge",
        url: "titan_fundamental",
        id: portfolioHashMap["titan_fundamental"],
        autoId: portfolioHashMap["titan_fundamental_auto"],
      },
    ],
  },
  everest: {
    ids: [
      portfolioHashMap["everest_growth"],
      portfolioHashMap["everest_low-risk-volatility"],
      portfolioHashMap["everest_fundamental"],
      portfolioHashMap["everest_defensive"],
      portfolioHashMap["everest_balanced"],
      // Include auto portfolio IDs
      portfolioHashMap["everest_growth_auto"],
      portfolioHashMap["everest_low-risk-volatility_auto"],
      portfolioHashMap["everest_fundamental_auto"],
      portfolioHashMap["everest_defensive_auto"],
      portfolioHashMap["everest_balanced_auto"],
    ],
    portfolios: [
      {
        name: "Momentum Ascent",
        url: "everest_growth",
        id: portfolioHashMap["everest_growth"],
        autoId: portfolioHashMap["everest_growth_auto"],
      },
      {
        name: "Resilient Horizon",
        url: "everest_low-risk-volatility",
        id: portfolioHashMap["everest_low-risk-volatility"],
        autoId: portfolioHashMap["everest_low-risk-volatility_auto"],
      },
      {
        name: "Hidden Value Discovery",
        url: "everest_fundamental",
        id: portfolioHashMap["everest_fundamental"],
        autoId: portfolioHashMap["everest_fundamental_auto"],
      },
      {
        name: "Capital Shield",
        url: "everest_defensive",
        id: portfolioHashMap["everest_defensive"],
        autoId: portfolioHashMap["everest_defensive_auto"],
      },
      {
        name: "Steady Climb",
        url: "everest_balanced",
        id: portfolioHashMap["everest_balanced"],
        autoId: portfolioHashMap["everest_balanced_auto"],
      },
    ],
  },
  core: {
    ids: [
      portfolioHashMap["core_growth"],
      portfolioHashMap["core_low-risk-volatility"],
      portfolioHashMap["core_balanced"],
    ],
    portfolios: [
      {
        name: "Capital Jetstream",
        url: "core_growth",
        id: portfolioHashMap["core_growth"],
        autoId: null, // No auto version for core
      },
      {
        name: "Safe Harbor",
        url: "core_low-risk-volatility",
        id: portfolioHashMap["core_low-risk-volatility"],
        autoId: null, // No auto version for core
      },
      {
        name: "Robust Anchor",
        url: "core_balanced",
        id: portfolioHashMap["core_balanced"],
        autoId: null, // No auto version for core
      },
    ],
  },
};

export const urlToNameMap = {
  atlas_growth: "Accelerated Growth",
  "atlas_low-risk-volatility": "Secure Bluechip",
  atlas_fundamental: "Undervalued Advantage",
  titan_growth: "Dynamic Upside",
  "titan_low-risk-volatility": "Steady Guard",
  titan_fundamental: "Fundamental Edge",
  everest_growth: "Momentum Ascent",
  "everest_low-risk-volatility": "Resilient Horizon",
  everest_fundamental: "Hidden Value Discovery",
  everest_defensive: "Capital Shield",
  everest_balanced: "Steady Climb",
  // Auto versions (sharing the same name mapping)
  atlas_growth_auto: "Accelerated Growth",
  "atlas_low-risk-volatility_auto": "Secure Bluechip",
  atlas_fundamental_auto: "Undervalued Advantage",
  titan_growth_auto: "Dynamic Upside",
  "titan_low-risk-volatility_auto": "Steady Guard",
  titan_fundamental_auto: "Fundamental Edge",
  everest_growth_auto: "Momentum Ascent",
  "everest_low-risk-volatility_auto": "Resilient Horizon",
  everest_fundamental_auto: "Hidden Value Discovery",
  everest_defensive_auto: "Capital Shield",
  everest_balanced_auto: "Steady Climb",
  // Core portfolios (no auto versions)
  core_growth: "Capital Jetstream",
  "core_low-risk-volatility": "Safe Harbor",
  core_balanced: "Robust Anchor",
};
